export interface PortalBookingPet {
    id: number;
    name: string;
    petType: string;
}

export interface PortalBookingAppointment {
    id: number;
    date: string;
    service: { id: number; name: string; businessArea: string | null };
    pet: PortalBookingPet;
    // Dates still open for add-ons, as YYYY-MM-DD in the business time zone.
    addonDates: Array<string>;
}

export interface PortalBookingAddon {
    id: number;
    addonServiceId: number;
    name: string;
    pet: PortalBookingPet;
    date: string | null;
    quantity: number;
    price: number;
    totalPrice: number;
}

export interface PortalBooking {
    id: number;
    marketplaceId: number;
    canAddAddons: boolean;
    totalPrice: number;
    appointments: Array<PortalBookingAppointment>;
    addons: Array<PortalBookingAddon>;
}

export interface PortalAddonEntry {
    uuid: string;
    petId: number;
    addonServiceId: number;
    date: string;
    quantity: number;
}

export const PortalAddonsErrorKind = {
    NotAvailable: 'not_available',
    PriceChanged: 'price_changed',
    AddonsUnavailable: 'addons_not_available',
    // Any other 4xx: the backend refused the request, the connection is fine.
    Rejected: 'rejected',
    // No answer or a 5xx.
    Unknown: 'unknown'
} as const;

export type PortalAddonsErrorKind =
    (typeof PortalAddonsErrorKind)[keyof typeof PortalAddonsErrorKind];

export interface PortalAddonsError {
    kind: PortalAddonsErrorKind;
    message: string;
    currentTotal?: number;
    // addons_not_available: positions in the request of the entries that can't be added.
    positions?: Array<number>;
}
